export class OrgMapping {
    orgName: string;
    costCenters: string[];

    constructor(orgName?: string) {
        this.orgName = orgName || '';
        this.costCenters = [];
    }
}
